import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableAppBlackoutsPostalCodesCatalog from './tableAppBlackoutsPostalCodesCatalog';
import tableBillingTransactionsSummary from './tableBillingTransactionsSummary';

export default {
  title: 'General',
  attributeName: 'teamsToCamera',
  fields: [
    {
      attributeName: 'id',
      label: 'Id',
      helpText: 'Id.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      hidden:true
    },
    {
      attributeName: 'visible',
      helpText: 'VFX visible to all records',
      type: FormInputTypes.SELECT,
      label: 'VFX Visible',
      placeholder: 'Please enter a valid value',
      options: [
        { name: 'True', value: 1 },
        { name: 'False', value: 0 },
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
    {
      attributeName: 'offset',
      helpText: 'VFX offset to all records',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'VFX Offset (ms)',
      placeholder: 'Please enter a valid value in milliseconds',
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'opentip',
      helpText: 'Opentip visible to all records',
      type: FormInputTypes.SELECT,
      label: 'Opentip',
      placeholder: 'Please enter a valid value',
      options: [
        { name: 'True', value: 1 },
        { name: 'False', value: 0 },
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
    {
      attributeName: 'threepointmade',
      helpText: 'Threepointmade visible to all records',
      type: FormInputTypes.SELECT,
      label: 'Threepoint made',
      placeholder: 'Please enter a valid value',
      options: [
        { name: 'True', value: 1 },
        { name: 'False', value: 0 },
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
    {
      attributeName: 'pointstreak',
      helpText: 'Pointstreak visible to all records',
      type: FormInputTypes.SELECT,
      label: 'Pointstreak',
      placeholder: 'Please enter a valid value',
      options: [
        { name: 'True', value: 1 },
        { name: 'False', value: 0 },
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
    {
      attributeName: 'teamtimeout',
      helpText: 'Teamtimeout visible to all records',
      type: FormInputTypes.SELECT,
      label: 'Teamtimeout',
      placeholder: 'Please enter a valid value',
      options: [
        { name: 'True', value: 1 },
        { name: 'False', value: 0 },
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
    {
      attributeName: 'crunchtime',
      helpText: 'Crunchtime visible to all records',
      type: FormInputTypes.SELECT,
      label: 'Crunchtime',
      placeholder: 'Please enter a valid value',
      options: [
        { name: 'True', value: 1 },
        { name: 'False', value: 0 },
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
    {
      attributeName: 'endgame',
      helpText: 'Endgame visible to all records',
      type: FormInputTypes.SELECT,
      label: 'Endgame',
      placeholder: 'Please enter a valid value',
      options: [
        { name: 'True', value: 1 },
        { name: 'False', value: 0 },
      ],
      emptyValue:true,
      default:'(Empty)', //default value to empty option
    },
  ],
};
